import React from "react";
import { computeTaskStats, statusBreakdown } from "../utils/taskStats";

const COLORS = {
    Open: "bg-info",
    "In Progress": "bg-warning",
    Paused: "bg-surface-3",
    Blocked: "bg-error",
    Completed: "bg-success",
};

const TaskAnalyticsPanel = ({ tasks }) => {
    const stats = computeTaskStats(tasks);
    const breakdown = statusBreakdown(tasks);
    const total = breakdown.reduce((s, b) => s + b.value, 0) || 1;

    const statCards = [
        { label: "Active", value: stats.active, color: "text-primary" },
        { label: "Due today", value: stats.dueToday, color: "text-info" },
        { label: "Overdue", value: stats.overdue, color: "text-error" },
        { label: "High priority", value: stats.highPriority, color: "text-warning" },
        { label: "Completed", value: stats.completed, color: "text-success" },
        { label: "Paused", value: stats.paused, color: "text-ink-muted" },
    ];

    return (
        <div className="space-y-4">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                {statCards.map(({ label, value, color }) => (
                    <div
                        key={label}
                        className="rounded-xl border border-line bg-surface-2 p-3"
                    >
                        <p className="text-[11px] uppercase tracking-wide text-ink-muted font-semibold">
                            {label}
                        </p>
                        <p className={`text-2xl font-bold mt-1 ${color}`}>{value}</p>
                    </div>
                ))}
            </div>

            <div className="rounded-xl border border-line bg-surface-2 p-4">
                <h3 className="text-sm font-semibold text-ink mb-3">Status breakdown</h3>
                <div className="space-y-2">
                    {breakdown.map(({ label, value }) => (
                        <div key={label}>
                            <div className="flex justify-between text-xs mb-1">
                                <span className="text-ink-secondary">{label}</span>
                                <span className="text-ink font-medium">{value}</span>
                            </div>
                            <div className="h-2 rounded-full bg-surface-3 overflow-hidden">
                                <div
                                    className={`h-full rounded-full transition-all ${COLORS[label] || "bg-primary"}`}
                                    style={{ width: `${(value / total) * 100}%` }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TaskAnalyticsPanel;
